import { render, staticRenderFns } from "./RainbowCove.vue?vue&type=template&id=4d04e917&scoped=true&"
import script from "./RainbowCove.vue?vue&type=script&lang=js&"
export * from "./RainbowCove.vue?vue&type=script&lang=js&"
import style0 from "./RainbowCove.vue?vue&type=style&index=0&id=4d04e917&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04e917",
  null
  
)

export default component.exports